import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { useBlockOrFieldType } from 'components/common-form/hooks/useBlockOrFieldType';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import type { IntlKey } from 'locales';
import { FC } from 'react';

export const UnknownFieldWarning: FC<{ id: string; value: string }> = ({ id, value }) => {
  const translationKey = useFieldTranslationKey(id);
  return (
    <BlockOrientationFormGroup inputId={id} label={`form.${translationKey}` as IntlKey}>
      <div className="input-group">
        <div className="input-group-text">
          <i className="icon text-warning">warning</i>
        </div>
        <input id={id} type="text" className="form-control is-warning text-warning" readOnly value={value} />
      </div>
    </BlockOrientationFormGroup>
  );
};

export const UnknownField: FC<ProductNodeBuilderProps> = ({ node: { id, type, children } }) => {
  const blockOrFieldType = useBlockOrFieldType(id, children);
  return <UnknownFieldWarning id={id} value={type ?? blockOrFieldType} />;
};

UnknownField.displayName = 'UnknownField';
